import moment from "moment-timezone";
import jwtDecode from "jwt-decode";

export const formatTime = (date = new Date(), format = "YYYY-MM-DD") => {
  if (date) {
    return moment(date).format(format);
  } else {
    return "";
  }
};

export const numFormat = (num) => {
  if (num) {
    return Number(num).toLocaleString();
  } else {
    return "";
  }
};

export const decodeJwt = (token) => {
  if (token) {
    return jwtDecode(token);
  } else {
    return {};
  }
};

export const getDistanceFromLatLonInKm = (lat1, lng1, lat2, lng2) => {
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lng2 - lng1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

export const parsePhoneNumber = (phoneNumber, token = " ") => {
  var phone = phoneNumber.replace(
    /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
    `$1${token}$2${token}$3`
  );
  return phone;
};

export function numberWithCommas(x) {
  if (x) {
    let onlyNumber = x.toString().replace(/,/gi, "");
    let parts = onlyNumber.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return parts.join(".");
  } else if (x === "") {
    return "";
  } else {
    return "0";
  }
}

export const postMessage = (param) => {
  try {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(param));
    } else {
      // console.log("can not post message");
    }
  } catch (err) {
    console.log("post Message Error", err);
  }
};

export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod|iOS/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

export const calcDate = (unit, value, base = new Date()) => {
  const copiedDate = new Date(base);
  switch (unit) {
    case "Y":
      copiedDate.setFullYear(copiedDate.getFullYear() + value);
      return copiedDate;
    case "M":
      copiedDate.setMonth(copiedDate.getMonth() + value);
      return copiedDate;
    default:
      copiedDate.setDate(copiedDate.getDate() + value);
      return copiedDate;
  }
};

export const encodeFileToBase64 = (fileBlob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(fileBlob);
  });
};

export const callPhone = (phoneNumber) => {
  window.location.href = "tel:" + phoneNumber;
};
